<template>
  <FichaEmpresa
    v-if="empresa"
    :empresa="empresa"
    :onBack="() => $router.push('/empresas')"
  ></FichaEmpresa>
</template>

<script>
import FichaEmpresa from "@/components/empresas/FichaEmpresa.vue";
import { tablesService } from "@/services";

export default {
  components: { FichaEmpresa },
  data: () => ({
    empresa: null,
  }),

  created() {
    tablesService
      .getService(`empresas/${this.$route.params.id}`)
      .then((empresa) => {
        this.empresa = empresa;
      })
      .catch(() => {
        this.$store.dispatch("alert/error", "No se pudo cargar la empresa.");
      });
  },
};
</script>

<style></style>
